module.exports = {
	"articleTitle1": "Fire suppression system issues briefly close South Quad dining hall ...",
	"catImage": "redstar.png",
	"totalCats": 1,
	"name": "South Quad",
	"videos": [
		"https://www.youtube.com/embed/qDturUoq55M"
	],
	"articleLink1": "#",
	"articleLink2": "https://www.michigandaily.com/section/news/potential-norovirus-continues-affect-students",
	"articleSnippet1": "Feb 7, 2017 ... South Quad dining hall, typically brimming with hungry students, was left empty \nTuesday night for a brief period of time because of issues with ...",
	"articleSnippet2": "Feb 18, 2016 ... Special precautions are being taken at South Quad and other University dining \nhalls to prevent the spread of contagious illnesses.",
	"totalMisc": 1,
	"articleTitle2": "UPDATE: University confirms norovirus in outbreak traced to South ...",
	"address": "600 E Madison St, Ann Arbor, MI 48109",
	"images": [],
	"position": {
		"lat": 42.273747,
		"lng": -83.742128
	},
	"tips": [
		{
			"text": "Arguably the best dining hall - very large selection, with above average food.",
			"person": "Bob Lesser"
		}
	],
	"bathroomrating": [
		{
			"rating": 4,
			"bathroom": "All Floors"
		}
	],
	"categories": {
		"dorm": 1,
		"misc": 1,
		"location": 1,
		"studyspot": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/southquad.json
// module id = 975
// module chunks = 0